import React from "react";
import "./Inventory-Land-Details.scss";

function InventoryLandDetails() {
  return (
    <div>
      <div className="pioneer-land">
        <div className="pioneer-land-content">
          <div className="pioneer-land-lower">
            <div className="pioneer-land-left">
              <div className="card-header">
                <img
                  src="\assets\images\Account-setting\InventoryLand.png"
                  alt="Pioneer-Land"
                  className="img-100"
                />
              </div>
            </div>
            <div className="pioneer-land-right flex-column ">
              <div className="d-flex some-right">
                <div className="right-1">
                  <h1>Pioneer Land</h1>
                  <h4>
                    Owned by <span className="text-primary">Astrality</span>
                    <img
                      className="mx-4 logo"
                      src="\assets\images\PioneerLandICon.svg"
                      alt="PioneerLandIcon"
                    />
                  </h4>
                  <p>
                    <img src="\assets\images\PioneerLandEye.svg" alt="" />
                    <span className="mx-2">5412 Views</span>
                  </p>
                  <h4>Highest Rent Offer</h4>
                  <p>$ 1.542</p>
                  <h4>
                    Rent Demand
                    <img
                      className="mx-3"
                      src="\assets\images\PioneerLandHigh.svg"
                      alt="PioneerLandHigh"
                    />
                    High
                  </h4>
                  <div className="setting">
                    <button>BUY NOW</button>
                  </div>
                </div>
                <div className="right-2">
                  <h4>Location</h4>
                  <p>Astra City</p>
                  <h4>Land Type</h4>
                  <p>Pioneer Land</p>
                  <h4>Coordinates</h4>
                  <p className="text-light-green">13.25.42</p>
                </div>
              </div>
              <div className="description ">
                <h4>Description</h4>
                <p>
                  Astra City is the urban hub of the heartbeat of Astrality.
                  Skyscrapers filled with virtual offices, buzzing digital
                  marketplaces, and lively social spaces make it a hotspot for
                  businesses and social butterflies alike. The city is the
                  fusion of modern and futuristic architecture, embodying the
                  spirit of progress and innovation that Astrality stands for.
                </p>
              </div>
            </div>
          </div>
          {/* Second Portion */}
          <div className="offer-recieved content-wrapper mt-4 ">
            <div className="offer-r-header  v-center justify-content-between">
              <h2 className="body-medium ">Rental Offer </h2>
            </div>
            <div className="offer-table ">
              <div className="table-header ">
                <p className="para cl-1">Offer</p>
                <p className="para cl-1">Offered By</p>
                <p className="para cl-1">Size</p>
                <p className="para  self-center"></p>
              </div>
              <div className="table-body">
                <div className="table-body-content mt-4">
                  <p className="para cl-1 mb-0 v-center ">USDT 543</p>
                  <p className="para cl-1 mb-0 v-center text-light-green">
                    Jinn Wilson
                  </p>
                  <p className="para  mb-0 v-center ">1x1</p>
                  <div className="self-center ">
                    <button>Rentout</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InventoryLandDetails;
